import { useQuery } from "@tanstack/react-query";
import { useLoginUser } from "@/hooks/useAuth";
import {
  fetchVersionChanges,
  versionChangesKey,
} from "@/services/roster/versionChanges";

export function useVersionChanges(
  groupId: string,
  scheduleId: string,
  enabled = true
) {
  const user = useLoginUser();
  return useQuery({
    queryKey: versionChangesKey(groupId, scheduleId),
    queryFn: ({ signal }) => fetchVersionChanges(groupId, scheduleId, signal),
    enabled: !!user && !!groupId && !!scheduleId && enabled,
    retry: false,
  });
}
